import { CustomDiv } from "@/common/divs";
import {
  AlmostBoldText,
  LightText,
  LightTextSpan,
  SemiBoldText,
} from "@/common/texts";

const LegalAdvice: React.FC = () => {
  return (
    <>
      <CustomDiv
        paddingY="16px"
        paddingX="30px"
        className="terms-and-conditions-card"
        style={{ border: "0px" }}
      >
        <LightText>
          Conforme a lo previsto en el artículo 10 de la Ley 34/2002, de 11 de
          julio, de Servicios de la Sociedad de la Información y Comercio
          Electrónico (en adelante LSSI), comunicamos, con respecto a la página
          vee.travel así como a la aplicación VEE Sightseeing (en adelante, el
          Sitio), los siguientes datos:
        </LightText>
        <SemiBoldText style={{ marginTop: "16px" }} fontSize="18px">
          1. TITULAR
        </SemiBoldText>

        <LightTextSpan style={{ marginTop: "16px" }}>
          Titular de la página web:{" "}
          <AlmostBoldText>VEE SIGHTSEER AGENCY, S.L.</AlmostBoldText> (en
          adelante “VSA”). Domicilio social: Carrer del Bruc 149, 4-2B, 08037,
          Barcelona (ESPAÑA). NIF: B-16890113. Sociedad inscrita en el Registro
          Mercantil de Barcelona, tomo 48016, folio 94, hoja B-569575,
          inscripción 1, de fecha 16 de julio de 2021.
        </LightTextSpan>
        <SemiBoldText fontSize="18px" style={{ marginTop: "16px" }}>
          2. COMUNICACIONES
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          Cualquier comunicación con VSA puede hacerse por cualquiera de los
          siguientes canales:
        </LightText>
        <LightText style={{ marginLeft: "32px" }}>
          • Por correo ordinario a nuestras oficinas: Carrer del Bruc 149, 4-2B,
          08037, Barcelona (ESPAÑA).
          <br />• Por e-mail a: info@vee.travel
        </LightText>

        <SemiBoldText fontSize="18px" style={{ marginTop: "16px" }}>
          3. OBJETO DEL SITIO
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          A través del Sitio, VSA promociona actividades, entre otras, de tipo
          deportivo, cultural, turístico, terapéuticas, estéticas, etc. de
          terceros (nuestros “Afiliados”), con el contenido y las condiciones
          ofertadas por estos terceros.
        </LightText>
        <SemiBoldText fontSize="18px" style={{ marginTop: "16px" }}>
          4. PRECIOS, IMPUESTOS Y POLÍTICA DE CANCELACIÓN
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          Para cada una de las actividades incluidas en el Sitio se detalla su
          precio y si éste incluye o no los impuestos y, en su caso y si los
          hubiere, los gastos de envío. Te recomendamos que revises la Política
          de Cancelación de cada Afiliado que aplica a cada actividad antes de
          contratarla.
        </LightText>
        <SemiBoldText fontSize="18px" style={{ marginTop: "16px" }}>
          5. REGULACIÓN
        </SemiBoldText>

        <LightTextSpan style={{ marginTop: "16px" }}>
          El acceso al Sitio te convierte en Usuario del mismo y te sujeta a las{" "}
          <a href="/terms-and-conditions">
            <AlmostBoldText style={{ textDecoration: "underline" }}>
              Condiciones de Uso y a la Política de Privacidad
            </AlmostBoldText>
          </a>{" "}
          que lo rigen y que se someten a la ley española.
        </LightTextSpan>
        <LightText style={{ marginTop: "16px" }}>
          VSA se reserva el derecho a modificar, en cualquier momento, la
          presentación y configuración del Sitio, así como el presente Aviso
          Legal junto con sus Condiciones de Uso y Política de Privacidad, por
          lo que te recomendamos leerlos cada vez que accedas al Sitio.
        </LightText>

        <LightText style={{ marginTop: "16px" }}>
          Fecha de publicación: 11 de Marzo de 2024
        </LightText>
      </CustomDiv>
    </>
  );
};

export default LegalAdvice;
